import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setOnlineStatus } from 'store';

export default function useOnlineStatus() {
  const dispatch = useDispatch();

  useEffect(() => {
    const updateStatus = () => dispatch(setOnlineStatus(navigator.onLine));

    window.addEventListener('offline', updateStatus);
    window.addEventListener('online', () => {
      updateStatus();
      window.location.reload();
    });
    updateStatus();

    return () => {
      window.removeEventListener('online', updateStatus);
      window.removeEventListener('offline', updateStatus);
    };
  }, [dispatch]);
}
